module.exports = __webpack_public_path__ + "img/BfA_pad.9e90b0e0.png";